export default {
    modelValue: {
        type: String,
        default: undefined
    }, 
    clearPromptChar: {
        type: Boolean,
        default: undefined
    }, 
    culture: {
        type: String,
        default: undefined
    }, 
    mask: {
        type: String,
        default: undefined
    }, 
    promptChar: {
        type: String,
        default: undefined
    }, 
    rules: {
        type: Object,
        default: undefined
    }, 
    unmaskOnPost: {
        type: Boolean,
        default: undefined
    }, 
    value: {
        type: String,
        default: undefined
    }, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/MaskedTextBoxProps.js